module.exports = __webpack_public_path__ + "assets/img/icon02.3c56331a.jpg";